import React from 'react';
import SideNavigation from '@component/SideNavigation';
import i18n from 'i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const SideNavComponent = (props) => {
  return (
    <>
      <SideNavigation
        sideNav={props.fields.navigations}
        closeText={i18n.t('button/close') || 'Close'}
        mobDropdownText={props.sitecoreContext.route.fields.navigationtitle?.value || props.sitecoreContext.route.fields.pagetitlelink?.value?.href}
      />
    </>
  );
};
export default withSitecoreContext()(SideNavComponent);
